import React, { useEffect, useState } from 'react';

const CirclesPlans = ({
  circlesPlans,
  circlesPlansEventsPlans: originalCirclesPlansEventsPlans,
  onChangeCirclesPlans,
}) => {
  const [circlesPlansEventsPlans, setCirclesPlansEventsPlans] = useState(
    originalCirclesPlansEventsPlans || []
  );

  useEffect(() => {
    onChangeCirclesPlans(circlesPlansEventsPlans);
  }, [circlesPlansEventsPlans]);

  const onChange = ({ circlesPlanId, discountRate }) => {
    setCirclesPlansEventsPlans((prev) => [
      ...prev.filter((item) => item.circles_plan_id !== circlesPlanId),
      { circles_plan_id: circlesPlanId, discount_rate: discountRate },
    ]);
  };

  return (
    <div className="shadow-sm mb-0 bg-white">
      <div className="container col-md-8 col-lg-6 border-top">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
          特典プランの割引率
        </p>
        {circlesPlans.map((plan) => (
          <CirclesPlan
            key={plan.id}
            circlesPlan={plan}
            circlesPlansEventsPlan={circlesPlansEventsPlans.find(
              (item) => item.circles_plan_id === plan.id
            )}
            onChange={onChange}
          />
        ))}
      </div>
    </div>
  );
};

const CirclesPlan = ({
  circlesPlan,
  circlesPlansEventsPlan = {},
  onChange,
}) => {
  return (
    <div className="ml-2 py-3 d-flex justify-content-between align-items-center">
      <div>{circlesPlan.name}</div>
      <select
        id="price_type"
        onChange={(e) =>
          onChange({
            circlesPlanId: circlesPlan.id,
            discountRate: Number(e.target.value),
          })
        }
        defaultValue={circlesPlansEventsPlan.discount_rate}
        style={{ width: 'auto' }}
        className="textarea--eventreport custom-select custom-select--makecircle text-dark"
      >
        {[...Array(11)].map((_, i) => (
          <option key={i} value={i * 10}>
            {i * 10}％
          </option>
        ))}
      </select>
    </div>
  );
};

export default CirclesPlans;
